var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('portal-target',{attrs:{"name":"main","multiple":""}}),_c('mounting-portal',{attrs:{"mount-to":"body","append":""}},[_c('notifications',{attrs:{"position":"bottom right"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }